'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

var _mobx = require('mobx');

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _layoutComponent = require('layout-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ConfirmationModalViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_BaseViewstore) {
    (0, _inherits3.default)(ConfirmationModalViewStore, _BaseViewstore);

    function ConfirmationModalViewStore() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ConfirmationModalViewStore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmationModalViewStore.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationModalViewStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showConfirmationModal', _descriptor, _this), _initDefineProp(_this, 'title', _descriptor2, _this), _initDefineProp(_this, 'message', _descriptor3, _this), _initDefineProp(_this, 'confirmLabel', _descriptor4, _this), _initDefineProp(_this, 'confirmBtnClass', _descriptor5, _this), _initDefineProp(_this, 'cancelLabel', _descriptor6, _this), _initDefineProp(_this, 'cancelBtnClass', _descriptor7, _this), _initDefineProp(_this, 'onConfirmFunc', _descriptor8, _this), _initDefineProp(_this, 'onCancelFunc', _descriptor9, _this), _initDefineProp(_this, 'viewDefinition', _descriptor10, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ConfirmationModalViewStore, [{
        key: 'resetModal',
        value: function resetModal() {
            var _this2 = this;

            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

            this.showConfirmationModal = false;
            var reset = function reset() {
                _this2.title = '';
                _this2.message = '';
                _this2.confirmLabel = '';
                _this2.confirmBtnClass = '';
                _this2.cancelLabel = '';
                _this2.cancelBtnClass = '';
                _this2.onConfirmFunc = null;
                _this2.onCancelFunc = null;
                _this2.viewDefinition = null;
            };

            if (delay === false) {
                reset();
            } else {
                setTimeout(reset, delay);
            }
        }
    }, {
        key: 'setModal',
        value: function setModal(newModal) {
            this.resetModal(false);
            this.showConfirmationModal = true;
            if (newModal.Component || newModal.contentModel) {
                this.viewDefinition = newModal;
            } else {
                (0, _assign2.default)(this, newModal);
            }
        }
    }, {
        key: 'setTitle',
        value: function setTitle() {
            if (this.title != undefined) {
                return this.title;
            } else {
                return false;
            }
        }
    }, {
        key: 'setMessage',
        value: function setMessage() {
            if (this.message != undefined) {
                return this.message;
            } else {
                return false;
            }
        }
    }, {
        key: 'setConfirmLabel',
        value: function setConfirmLabel() {
            if (this.confirmLabel != undefined && this.confirmLabel) {
                return this.confirmLabel;
            } else {
                return false;
            }
        }
    }, {
        key: 'setConfirmBtnClass',
        value: function setConfirmBtnClass() {
            if (this.confirmBtnClass != undefined) {
                return this.validateClass(String(this.confirmBtnClass));
            } else {
                return '';
            }
        }
    }, {
        key: 'setCancelLabel',
        value: function setCancelLabel() {
            if (this.cancelLabel != undefined && this.cancelLabel !== '') {
                return this.cancelLabel;
            } else {
                return false;
            }
        }
    }, {
        key: 'setCancelBtnClass',
        value: function setCancelBtnClass() {
            if (this.cancelBtnClass != undefined) {
                return this.validateClass(String(this.cancelBtnClass));
            } else {
                return '';
            }
        }
    }, {
        key: 'onCancel',
        value: function onCancel(e) {
            if (this.onCancelFunc != undefined && typeof this.onCancelFunc == 'function') {
                this.onCancelFunc(e);
            } else {
                this.resetModal();
            }
        }
    }, {
        key: 'onConfirm',
        value: function onConfirm(e) {
            if (this.onConfirmFunc != undefined && typeof this.onConfirmFunc == 'function') {
                this.onConfirmFunc(e);
            } else {
                this.resetModal();
            }
        }
    }, {
        key: 'validateClass',
        value: function validateClass(str) {
            if (str !== '') {
                if (str.indexOf(' ') !== 0) {
                    return ' ' + str;
                } else {
                    return str;
                }
            } else {
                return str;
            }
        }
    }, {
        key: 'Component',
        get: function get() {
            return !!this.viewDefinition && (0, _layoutComponent.getSelectedView)(this.viewDefinition);
        }
    }]);
    return ConfirmationModalViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'showConfirmationModal', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'message', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'confirmLabel', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'confirmBtnClass', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'cancelLabel', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'cancelBtnClass', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'onConfirmFunc', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'onCancelFunc', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'viewDefinition', [_dec], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _applyDecoratedDescriptor(_class.prototype, 'Component', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'Component'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetModal', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetModal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setModal', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setModal'), _class.prototype)), _class));
;

var _default = ConfirmationModalViewStore;
exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ConfirmationModalViewStore, 'ConfirmationModalViewStore', 'src/core_modules/confirmation-modal/viewstore.jsx');

    __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/confirmation-modal/viewstore.jsx');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/confirmation-modal/viewstore.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/confirmation-modal/viewstore.js
// module chunks = 0